import { IKVP } from 'configs/interfaces';

export const REGION = 'europe-west3';

export const EVENTTIMEZONE = 'Europe/Berlin';

export const firebaseConfig = {
	apiKey: 'AIzaSyBix00bDuI_0UasyecnPT271dUMY-Ple3g',
	authDomain: 'bits22.firebaseapp.com',
	projectId: 'bits22',
	storageBucket: 'bits22.appspot.com',
	messagingSenderId: '610929323812',
	appId: '1:610929323812:web:22476d1c48904face94db1',
};

export const RESOLVETOKENURL = 'https://europe-west3-bits22.cloudfunctions.net/resolveUserToken';
export const BOOKSLOTURL = 'https://europe-west3-bits22.cloudfunctions.net/bookSlot';
export const CHECKTICKETCODEURL = 'https://europe-west3-bits22.cloudfunctions.net/checkTicketCode';
export const CANCELSLOTURL = 'https://europe-west3-bits22.cloudfunctions.net/cancelSlot';

export const numberOfSlots = 2;
export const maximumNumberOfTableCaptains = 2;
export const EVENTCODE = 'bits26';
export const APPLICATIONURL = 'https://tc.bitsandpretzels.com';
export const EVENTTITLE = 'Bits & Pretzels - Table Captain Booking';
export const FAVICONURL = '/favicon.ico';

export const CATEGORY2FILTERS: IKVP[] = [
	{
		key: 'tablecaptain',
		label: 'Table Captains',
	},
	{
		key: 'topictable',
		label: 'Tribe Hubs',
	},
];

export const CATEGORY3FILTERS: IKVP[] = [
	{
		key: 'Founder',
		label: 'Founder',
	},
	{
		key: 'Investor',
		label: 'Investor',
	},
	{
		key: 'Corporate',
		label: 'Corporate',
	},
	{
		key: 'CIO',
		label: 'CIO',
	},
	{
		key: 'Media',
		label: 'Media',
	},
	{
		key: 'Creator',
		label: 'Creator',
	},
];

// Tribe Hub filters/sections, shown in this order (the "All" button is added by FilterCloud).
// key must match the teamCategory4 value delivered by the CMS.
export const teamCategory4: IKVP[] = [
	{
		key: 'Tribe Hubs',
		label: 'Tribe Hubs',
	},
	{
		key: 'Free Seating Area',
		label: 'Free Seating',
	},
];

export const slotTimes = [
	{
		startDate: '30.09.2026 10:45',
		endDate: '30.09.2026 11:30',
	},
	{
		startDate: '30.09.2026 11:45',
		endDate: '30.09.2026 12:30',
	},
];
